import React from "react";
import { Container } from "../styles/Container.styled";
import styled from "styled-components";
import { Link } from "gatsby";
import logoIcon from "../images/Witz-logo.svg";

const Header = ({ pageTilte }) => {
	return (
		<StyleHeader>
			<Container>
				<Link to='/'>
					<img src={logoIcon} alt='logo' className='logo' />
				</Link>
				<Title>{pageTilte}</Title>
			</Container>
		</StyleHeader>
	);
};

const StyleHeader = styled.header`
	background-color: #1b1b1b;
	height: 153px;
	display: flex;
	align-items: center;
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	.logo {
		width: 99px;
	}
	@media (max-width: 768px) {
		height: 119px;
		text-align: center;
		.logo {
			width: 79px;
		}
	}
`;

const Title = styled.div`
	font-size: 25px;
	font-weight: 600;
	padding-top: 20px;
	@media (max-width: 768px) {
		font-size: 21px;
	}
`;

export default Header;
